import 'lbs-jqlayout/layout-default-latest.css';

import 'lbs-jqknob'; // rotation dial
import 'lbs-jqlayout'; // uScope viewport layout
import { X2JS } from 'lbs-x2js'; // legacy ajax, xinfo
import 'lbs-raphael'; // annotations

window.X2JS = X2JS;



// WEBPACK FOOTER //
// ./src/lib/vendor/uscope.js